import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Storage, Translate, translate } from 'react-jhipster';
import '../../user/profile.scss';
import '../../../sendOtp/sendOtp.scss';
import OtpInput from 'react-otp-input';
import { reSendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import { MESSAGE, Rester_Type } from 'app/config/constants';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { sendOtp } from 'app/modules/account/user/user.reducer';

export interface IVerifyOtpEditAuthProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  invokeCloseModal: Function;
  invokeSuccess: Function;
  id: any;
  type: any;
}

export interface IVerifyOtpEditAuthState {
  otp: string;
  visible: boolean;
  color: string;
  message: string;
  timeLeft: number;
  timerOn: boolean;
  isDisable: boolean;
  redirectUrl: boolean;
  alertMess: string;
  isOpenAlert: boolean;
}

export class VerifyOtpEditAuth extends React.Component<IVerifyOtpEditAuthProps, IVerifyOtpEditAuthState> {
  timerID = null;
  state: IVerifyOtpEditAuthState = {
    otp: '',
    visible: false,
    color: 'info',
    message: '',
    timeLeft: 0,
    timerOn: false,
    isDisable: false,
    redirectUrl: false,
    alertMess: '',
    isOpenAlert: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.resVerifyOtp !== nextProps.resVerifyOtp) {
      const { resVerifyOtp } = nextProps;
      if (resVerifyOtp && resVerifyOtp.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          visible: true,
          color: 'danger',
          message: resVerifyOtp.message,
          otp: ''
        });
      } else if (resVerifyOtp && resVerifyOtp.status !== 'SUCCESS') {
        this.setState({
          visible: true,
          color: 'danger',
          message: resVerifyOtp.message
        });
      } else if (resVerifyOtp.status === 'SUCCESS') {
        this.props.invokeSuccess();
      }
    }

    if (this.props.responseReSend !== nextProps.responseReSend) {
      const { responseReSend } = nextProps;
      if (responseReSend && responseReSend.status === 'SUCCESS') {
        Storage.session.remove('count');
        let { id } = this.props;
        this.setState({
          visible: true,
          color: 'success',
          message:
            id.indexOf('@') > 0 ? translate('sendOtp.messages.sendotpSuccessTypeEmail') : translate('sendOtp.messages.sendotpSuccess'),
          otp: ''
        });
      } else if (responseReSend && responseReSend.status) {
        this.props.generateCaptcha();
        this.setState({
          color: 'danger',
          alertMess: responseReSend.message,
          isOpenAlert: true
        });
      }
      this.props.generateCaptcha();
    }

    if (this.props.registrationFailure !== nextProps.registrationFailure) {
      if (this.props.registrationFailure) {
        this.setState({
          visible: true,
          color: 'danger',
          message: 'Có lỗi xảy ra xảy ra. Xin vui lòng thử lại sau!'
        });
      }
    }
    let timerId = setTimeout(() => {
      this.setState({
        visible: false
      });
    }, 10000);
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  toggle = () => {
    this.props.invokeCloseModal();
  };
  handleValidSubmit = () => {
    if (this.state.otp) {
      this.props.sendOtp(this.props.id, this.state.otp);
    } else {
      this.setState({
        visible: true,
        color: 'info',
        message: 'Bạn chưa nhập mã OTP.',
        isDisable: false
      });
      let timerId = setTimeout(() => {
        this.setState({
          visible: false
        });
      }, 3000);
    }
  };

  handleReSendOtp = () => {
    const { id } = this.props;
    this.props.reSendOtp(id, 'EMAIL', MESSAGE.OTP);

    this.setState({
      timerOn: true,
      timeLeft: 120
    });
  };

  tick = () => {
    if (this.state.timerOn && this.state.timeLeft > 0) {
      this.setState({ timeLeft: this.state.timeLeft - 1 });
    } else {
      this.setState({ timerOn: false });
    }
  };

  isDataEmpty(ob) {
    for (var i in ob) {
      return false;
    }
    return true;
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleValidSubmit();
    }
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  encryptoPhone = () => {
    var sdt = '';
    if (!this.isDataEmpty(this.props.infoNewPhone)) {
      let mobile = this.props.infoNewPhone.phone.startsWith('84')
        ? this.props.infoNewPhone.phone.replace('84', '0')
        : this.props.infoNewPhone.phone;
      sdt = mobile.slice(0, 3) + '****' + mobile.slice(7, mobile.length);
    }
    return sdt;
  };

  render() {
    const { id } = this.props;

    return (
      <div className="container-fluid">
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '25%' }}
        >
          <ModalHeader toggle={this.toggle} />
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', height: '550px', overflow: 'auto' }}>
            <Row className="justify-content-center">
              <Col className="box-otp">
                <h2 className="text-center font-weight-bold" id="password-title">
                  <Translate contentKey="sendOtp.title">Nhập mã OTP</Translate>
                </h2>
                <h6 className="text-center txtContent font-weight-bold">
                  <Translate contentKey="sendOtp.txtContent1" interpolate={{ email: id }}>
                    {/*Otp code has been sent via phone number: {!this.isDataEmpty(this.props.infoNewPhone) ? this.encryptoPhone() : sdt}*/}
                  </Translate>
                </h6>

                <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                  {this.state.message}
                </Alert>

                <AvForm className="text-center" id="password-form" onValidSubmit={this.handleValidSubmit} onKeyPress={this.handleKeyPress}>
                  <p className="text-center">Nhập mã OTP</p>
                  <div id="inputOtp">
                    <OtpInput
                      inputStyle={{
                        width: '2.5rem',
                        height: '2.5rem',
                        margin: '5px 5px',
                        fontSize: '1.5rem',
                        borderRadius: 4,
                        border: '1px solid rgba(0,0,0,0.3)'
                      }}
                      numInputs={6}
                      onChange={otp => this.setState({ otp })}
                      value={this.state.otp}
                      shouldAutoFocus
                    />
                  </div>
                  <p className="text-center">
                    <label className="label-otp">
                      {this.state.timeLeft === 0 ? 'Bạn chưa nhận được mã?' : 'Lấy lại mã sau thời gian:'}
                    </label>
                    {this.state.timeLeft === 0 ? (
                      <Button className="btnLink" color="link" type="button" onClick={() => this.handleReSendOtp()}>
                        GỬI LẠI NGAY
                      </Button>
                    ) : (
                      <Button className="btnLink" color="link" type="button">
                        {this.state.timeLeft}s
                      </Button>
                    )}
                  </p>
                  <Button className="btn-register" type="submit" disabled={this.state.isDisable} block>
                    <Translate contentKey="sendOtp.form.button">Confirm</Translate>
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resVerifyOtp: storeState.userInfo.resVerifyOtp,
  responseReSend: storeState.sendotp.responseReSend,
  infoNewPhone: storeState.sendotp.infoNewPhone,
  userProfile: storeState.userInfo.userProfile,
  registrationFailure: storeState.sendotp.registrationFailure
});
const mapDispatchToProps = { reSendOtp, sendOtp, generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyOtpEditAuth);
